<template>
  <iframe
    style="height:100% !important;width:100% !important;"
    frameborder="0"
    allowfullscreen="true"
    allow="fullscreen; accelerometer; gyroscope; magnetometer; vr; camera; microphone"
    :src="iframeSource()"
  ></iframe>
</template>

<script>
export default {
  data: () => ({}),
  props: {
    gameID: String,
    source: String
  },
  mounted() {
    // We expect a message to be posted from the pano iframe like this:
    //  window.parent.postMessage({message: 'hotspot_clicked', data: { hotspot: 'window' }}, "*");
    //
    window.addEventListener('message', this.messageHandler)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.messageHandler)
  },
  methods: {
    messageHandler(event) {
      if (event.data.message === 'hotspot_clicked') {
        this.hotspotClicked(event.data)
      }
    },
    hotspotClicked(data) {
      this.$emit('hotspot-clicked', data.data.hotspot)
    },
    iframeSource() {
      if (this.source.includes('//')) {
        return this.source
      }

      return (
        process.env.VUE_APP_API_BASE_URL +
        '/../assets/' +
        this.gameID +
        '/' +
        this.source
      )
    }
  }
}
</script>

<style scoped></style>
